export enum ErEnum { // TODO: check ErEnum references
  // FRONT

  FRONT_RESPONSE_CODE_IS_NOT_201 = 'FRONT_RESPONSE_CODE_IS_NOT_201',
  FRONT_RESPONSE_INFO_STATUS_IS_NOT_OK = 'FRONT_RESPONSE_INFO_STATUS_IS_NOT_OK',

  FRONT_INSTANCE_OF_HTTP_ERROR_RESPONSE = 'FRONT_INSTANCE_OF_HTTP_ERROR_RESPONSE',
  FRONT_INSTANCE_OF_TIMEOUT_ERROR = 'FRONT_INSTANCE_OF_TIMEOUT_ERROR',
  FRONT_API_UNKNOWN_ERROR = 'FRONT_API_UNKNOWN_ERROR',

  FRONT_FORBIDDEN_REPO = 'FRONT_FORBIDDEN_REPO',
  FRONT_BRANCH_DOES_NOT_EXIST = 'FRONT_BRANCH_DOES_NOT_EXIST',
  FRONT_CANNOT_SWITCH_BRANCH_WHILE_SELECTED_REPO_HAS_UNCOMMITTED_CHANGES = 'FRONT_CANNOT_SWITCH_BRANCH_WHILE_SELECTED_REPO_HAS_UNCOMMITTED_CHANGES',
  FRONT_CURRENT_FILE_NOT_FOUND = 'FRONT_CURRENT_FILE_NOT_FOUND',

  //

  INTERNAL_ERROR = 'INTERNAL_ERROR',
  TOO_MANY_REQUESTS_ERROR = 'TOO_MANY_REQUESTS_ERROR',
  THROTTLER_ERROR = 'THROTTLER_ERROR',

  // BACKEND

  BACKEND_APP_TERMINATED = 'BACKEND_APP_TERMINATED',
  BACKEND_UNCAUGHT_EXCEPTION = 'BACKEND_UNCAUGHT_EXCEPTION',
  BACKEND_UNHANDLED_REJECTION_REASON = 'BACKEND_UNHANDLED_REJECTION_REASON',
  BACKEND_UNHANDLED_REJECTION_ERROR = 'BACKEND_UNHANDLED_REJECTION_ERROR',

  BACKEND_WRONG_ENV_VALUES = 'BACKEND_WRONG_ENV_VALUES',

  BACKEND_HASH_SECRET_IS_NOT_DEFINED = 'BACKEND_HASH_SECRET_IS_NOT_DEFINED',
  BACKEND_DCONFIG_IS_NOT_DEFINED = 'BACKEND_DCONFIG_IS_NOT_DEFINED',

  BACKEND_ENCRYPT_METADATA_DOES_NOT_WORK_WITHOUT_ENCRYPT_DB = 'BACKEND_ENCRYPT_METADATA_DOES_NOT_WORK_WITHOUT_ENCRYPT_DB',

  BACKEND_AES_KEY_IS_NOT_DEFINED = 'BACKEND_AES_KEY_IS_NOT_DEFINED',
  BACKEND_AES_KEY_TAG_IS_NOT_DEFINED = 'BACKEND_AES_KEY_TAG_IS_NOT_DEFINED',
  BACKEND_PREV_AES_KEY_IS_DEFINED_BUT_PREV_AES_KEY_TAG_IS_NOT_DEFINED = 'BACKEND_PREV_AES_KEY_IS_DEFINED_BUT_PREV_AES_KEY_TAG_IS_NOT_DEFINED',

  BACKEND_DB_RECORD_IS_DECRYPTED_BUT_HAS_KEY_TAG = 'BACKEND_DB_RECORD_IS_DECRYPTED_BUT_HAS_KEY_TAG',
  BACKEND_DB_RECORD_HAS_BOTH_DECRYPTED_AND_ENCRYPTED_PROPS = 'BACKEND_DB_RECORD_HAS_BOTH_DECRYPTED_AND_ENCRYPTED_PROPS',
  BACKEND_DB_RECORD_HAS_NO_DECRYPTED_AND_NO_ENCRYPTED_PROPS = 'BACKEND_DB_RECORD_HAS_NO_DECRYPTED_AND_NO_ENCRYPTED_PROPS',
  BACKEND_DB_RECORD_KEY_TAG_DOES_NOT_MATCH_CURRENT_OR_PREV = 'BACKEND_DB_RECORD_KEY_TAG_DOES_NOT_MATCH_CURRENT_OR_PREV',
  BACKEND_DB_RECORDS_EXIST_WITH_KEY_TAGS_THAT_DO_NOT_MATCH_CURRENT_OR_PREV = 'BACKEND_DB_RECORDS_EXIST_WITH_KEY_TAGS_THAT_DO_NOT_MATCH_CURRENT_OR_PREV',

  BACKEND_USER_ALIAS_IS_UNDEFINED = 'BACKEND_USER_ALIAS_IS_UNDEFINED',

  BACKEND_WRONG_REQUEST_INFO_NAME = 'BACKEND_WRONG_REQUEST_INFO_NAME',
  BACKEND_WRONG_REQUEST_PARAMS = 'BACKEND_WRONG_REQUEST_PARAMS',

  BACKEND_MUTUALLY_EXCLUSIVE_PARAMS = 'BACKEND_MUTUALLY_EXCLUSIVE_PARAMS',
  BACKEND_DASHBOARD_ID_CHART_ID_AND_REPORT_ID_ARE_NOT_DEFINED = 'BACKEND_DASHBOARD_ID_CHART_ID_AND_REPORT_ID_ARE_NOT_DEFINED',
  BACKEND_TILE_INDEX_DOES_NOT_WORK_WITHOUT_DASHBOARD_ID = 'BACKEND_TILE_INDEX_DOES_NOT_WORK_WITHOUT_DASHBOARD_ID',
  BACKEND_ROW_ID_DOES_NOT_WORK_WITHOUT_REPORT_ID = 'BACKEND_ROW_ID_DOES_NOT_WORK_WITHOUT_REPORT_ID',
  BACKEND_SLEEP_DOES_NOT_WORK_WITHOUT_WAIT = 'BACKEND_SLEEP_DOES_NOT_WORK_WITHOUT_WAIT',

  BACKEND_ERROR_CODE_FROM_BACKEND = 'BACKEND_ERROR_CODE_FROM_BACKEND',

  BACKEND_ERROR_RESPONSE_FROM_DISK = 'BACKEND_ERROR_RESPONSE_FROM_DISK',
  BACKEND_ERROR_RESPONSE_FROM_BLOCKML = 'BACKEND_ERROR_RESPONSE_FROM_BLOCKML',
  BACKEND_ERROR_RESPONSE_FROM_BACKEND = 'BACKEND_ERROR_RESPONSE_FROM_BACKEND',

  BACKEND_USER_ALREADY_REGISTERED = 'BACKEND_USER_ALREADY_REGISTERED',
  BACKEND_USER_IS_NOT_INVITED = 'BACKEND_USER_IS_NOT_INVITED',

  BACKEND_USER_DOES_NOT_EXIST = 'BACKEND_USER_DOES_NOT_EXIST',

  BACKEND_THROTTLER_USER_ID_IS_NOT_DEFINED = 'BACKEND_THROTTLER_USER_ID_IS_NOT_DEFINED',

  BACKEND_DATE_CONVERSION_FAILED = 'BACKEND_DATE_CONVERSION_FAILED',

  BACKEND_USER_IS_ORG_OWNER = 'BACKEND_USER_IS_ORG_OWNER',
  BACKEND_USER_IS_THE_ONLY_PROJECT_ADMIN = 'BACKEND_USER_IS_THE_ONLY_PROJECT_ADMIN',

  BACKEND_SIGN_UP_TO_SET_PASSWORD = 'BACKEND_SIGN_UP_TO_SET_PASSWORD',
  BACKEND_WRONG_PASSWORD = 'BACKEND_WRONG_PASSWORD',

  BACKEND_UNAUTHORIZED = 'BACKEND_UNAUTHORIZED',
  BACKEND_NOT_AUTHORIZED = 'BACKEND_NOT_AUTHORIZED',
  BACKEND_WRONG_SPECIAL_KEY = 'BACKEND_WRONG_SPECIAL_KEY',

  BACKEND_UPDATE_PASSWORD_WRONG_TOKEN = 'BACKEND_UPDATE_PASSWORD_WRONG_TOKEN',
  BACKEND_UPDATE_PASSWORD_TOKEN_EXPIRED = 'BACKEND_UPDATE_PASSWORD_TOKEN_EXPIRED',

  BACKEND_TEST_ROUTES_FORBIDDEN = 'BACKEND_TEST_ROUTES_FORBIDDEN',

  BACKEND_ORG_ALREADY_EXISTS = 'BACKEND_ORG_ALREADY_EXISTS',
  BACKEND_ORG_DOES_NOT_EXIST = 'BACKEND_ORG_DOES_NOT_EXIST',
  BACKEND_FORBIDDEN_ORG = 'BACKEND_FORBIDDEN_ORG',
  BACKEND_ONLY_ORG_OWNER_CAN_ACCESS = 'BACKEND_ONLY_ORG_OWNER_CAN_ACCESS',
  BACKEND_NEW_OWNER_NOT_FOUND = 'BACKEND_NEW_OWNER_NOT_FOUND',
  BACKEND_CREATION_OF_ORGANIZATIONS_IS_FORBIDDEN = 'BACKEND_CREATION_OF_ORGANIZATIONS_IS_FORBIDDEN',
  BACKEND_USER_IS_NOT_SERVER_ADMIN = 'BACKEND_USER_IS_NOT_SERVER_ADMIN',

  BACKEND_NOTE_DOES_NOT_EXIST = 'BACKEND_NOTE_DOES_NOT_EXIST',

  BACKEND_PROJECT_ALREADY_EXISTS = 'BACKEND_PROJECT_ALREADY_EXISTS',
  BACKEND_PROJECT_DOES_NOT_EXIST = 'BACKEND_PROJECT_DOES_NOT_EXIST',
  BACKEND_RESTRICTED_ORGANIZATION_NAME = 'BACKEND_RESTRICTED_ORGANIZATION_NAME',
  BACKEND_RESTRICTED_ORGANIZATION = 'BACKEND_RESTRICTED_ORGANIZATION',
  BACKEND_RESTRICTED_PROJECT = 'BACKEND_RESTRICTED_PROJECT',
  BACKEND_RESTRICTED_USER = 'BACKEND_RESTRICTED_USER',
  BACKEND_USER_PROFILE_CODEX_AUTH_NOT_SET = 'BACKEND_USER_PROFILE_CODEX_AUTH_NOT_SET',
  BACKEND_CODEX_AUTH_SIGN_IN_REQUIRED = 'BACKEND_CODEX_AUTH_SIGN_IN_REQUIRED',
  BACKEND_CODEX_DEVICE_AUTH_START_FAILED = 'BACKEND_CODEX_DEVICE_AUTH_START_FAILED',
  BACKEND_CODEX_AUTH_TOKEN_EXPIRES_IN_IS_MISSING = 'BACKEND_CODEX_AUTH_TOKEN_EXPIRES_IN_IS_MISSING',
  BACKEND_CODEX_AUTH_TOKEN_EXPIRES_IN_IS_TOO_SHORT = 'BACKEND_CODEX_AUTH_TOKEN_EXPIRES_IN_IS_TOO_SHORT',

  BACKEND_MEMBER_IS_NOT_EXPLORER = 'BACKEND_MEMBER_IS_NOT_EXPLORER',
  BACKEND_MEMBER_IS_NOT_ADMIN = 'BACKEND_MEMBER_IS_NOT_ADMIN',
  BACKEND_MEMBER_IS_NOT_EDITOR = 'BACKEND_MEMBER_IS_NOT_EDITOR',
  BACKEND_MEMBER_IS_NOT_EDITOR_OR_ADMIN = 'BACKEND_MEMBER_IS_NOT_EDITOR_OR_ADMIN',
  BACKEND_MEMBER_ALREADY_EXISTS = 'BACKEND_MEMBER_ALREADY_EXISTS',
  BACKEND_MEMBER_DOES_NOT_EXIST = 'BACKEND_MEMBER_DOES_NOT_EXIST',
  BACKEND_ADMIN_CANNOT_DELETE_HIMSELF = 'BACKEND_ADMIN_CANNOT_DELETE_HIMSELF',
  BACKEND_ADMIN_CANNOT_CHANGE_HIS_ADMIN_STATUS = 'BACKEND_ADMIN_CANNOT_CHANGE_HIS_ADMIN_STATUS',

  BACKEND_CONNECTION_ALREADY_EXISTS = 'BACKEND_CONNECTION_ALREADY_EXISTS',
  BACKEND_CONNECTION_DOES_NOT_EXIST = 'BACKEND_CONNECTION_DOES_NOT_EXIST',
  BACKEND_CONNECTION_TYPE_IS_NOT_SUPPORTED_FOR_SAMPLE = 'BACKEND_CONNECTION_TYPE_IS_NOT_SUPPORTED_FOR_SAMPLE',
  BACKEND_CONNECTION_SCHEMA_IS_NOT_FOUND = 'BACKEND_CONNECTION_SCHEMA_IS_NOT_FOUND',
  BACKEND_PROVIDER_ALREADY_EXISTS = 'BACKEND_PROVIDER_ALREADY_EXISTS',
  BACKEND_PROVIDER_DOES_NOT_EXIST = 'BACKEND_PROVIDER_DOES_NOT_EXIST',
  BACKEND_PROVIDER_IS_DISABLED = 'BACKEND_PROVIDER_IS_DISABLED',
  BACKEND_PROVIDER_TYPE_MISMATCH = 'BACKEND_PROVIDER_TYPE_MISMATCH',
  BACKEND_PROVIDER_API_KEY_REQUIRED = 'BACKEND_PROVIDER_API_KEY_REQUIRED',
  BACKEND_PROVIDER_NOT_VALID_API_KEY = 'BACKEND_PROVIDER_NOT_VALID_API_KEY',
  BACKEND_PROVIDER_HEADER_VALUE_REQUIRED = 'BACKEND_PROVIDER_HEADER_VALUE_REQUIRED',
  BACKEND_PROVIDER_MODEL_DISCOVERY_FAILED = 'BACKEND_PROVIDER_MODEL_DISCOVERY_FAILED',
  BACKEND_PROVIDER_MODEL_NOT_DISCOVERED = 'BACKEND_PROVIDER_MODEL_NOT_DISCOVERED',
  BACKEND_PROVIDER_MODEL_ALREADY_EXISTS = 'BACKEND_PROVIDER_MODEL_ALREADY_EXISTS',
  BACKEND_PROVIDER_MODEL_DOES_NOT_EXIST = 'BACKEND_PROVIDER_MODEL_DOES_NOT_EXIST',
  BACKEND_PROVIDER_MODEL_NOT_AVAILABLE_IN_EXPLORER = 'BACKEND_PROVIDER_MODEL_NOT_AVAILABLE_IN_EXPLORER',
  BACKEND_PROVIDER_MODEL_NOT_AVAILABLE_IN_BUILDER = 'BACKEND_PROVIDER_MODEL_NOT_AVAILABLE_IN_BUILDER',
  BACKEND_PROVIDER_MODEL_VARIANTS_INVALID = 'BACKEND_PROVIDER_MODEL_VARIANTS_INVALID',
  BACKEND_PROVIDER_MODEL_VARIANT_NOT_AVAILABLE = 'BACKEND_PROVIDER_MODEL_VARIANT_NOT_AVAILABLE',
  BACKEND_PROVIDER_MODEL_CONTEXT_LIMIT_REQUIRED = 'BACKEND_PROVIDER_MODEL_CONTEXT_LIMIT_REQUIRED',
  BACKEND_PROVIDER_MODEL_LIMIT_INVALID = 'BACKEND_PROVIDER_MODEL_LIMIT_INVALID',
  BACKEND_WRONG_SCHEMA_NAME = 'BACKEND_WRONG_SCHEMA_NAME',
  BACKEND_WRONG_TABLE_NAME = 'BACKEND_WRONG_TABLE_NAME',
  BACKEND_WRONG_COLUMN_NAME = 'BACKEND_WRONG_COLUMN_NAME',
  BACKEND_WRONG_OFFSET = 'BACKEND_WRONG_OFFSET',

  BACKEND_FORBIDDEN_REPO_ID = 'BACKEND_FORBIDDEN_REPO_ID',

  BACKEND_MANUAL_COMMIT_TO_PRODUCTION_REPO_IS_FORBIDDEN = 'BACKEND_MANUAL_COMMIT_TO_PRODUCTION_REPO_IS_FORBIDDEN',

  BACKEND_BRANCH_ALREADY_EXISTS = 'BACKEND_BRANCH_ALREADY_EXISTS',
  BACKEND_BRANCH_DOES_NOT_EXIST = 'BACKEND_BRANCH_DOES_NOT_EXIST',
  BACKEND_DEFAULT_BRANCH_CANNOT_BE_DELETED = 'BACKEND_DEFAULT_BRANCH_CANNOT_BE_DELETED',
  BACKEND_PRODUCTION_REPO_NOT_ALLOWED = 'BACKEND_PRODUCTION_REPO_NOT_ALLOWED',
  BACKEND_SESSION_BRANCH_CANNOT_BE_CREATED = 'BACKEND_SESSION_BRANCH_CANNOT_BE_CREATED',
  BACKEND_SESSION_BRANCH_CANNOT_BE_DELETED = 'BACKEND_SESSION_BRANCH_CANNOT_BE_DELETED',
  BACKEND_SESSION_BRANCH_CANNOT_BE_MERGED = 'BACKEND_SESSION_BRANCH_CANNOT_BE_MERGED',
  BACKEND_SESSION_REPO_CANNOT_BE_REVERTED_TO_REMOTE = 'BACKEND_SESSION_REPO_CANNOT_BE_REVERTED_TO_REMOTE',
  BACKEND_SESSION_TYPE_IS_NOT_EDITOR = 'BACKEND_SESSION_TYPE_IS_NOT_EDITOR',
  BACKEND_SESSION_TYPE_IS_NOT_EXPLORER = 'BACKEND_SESSION_TYPE_IS_NOT_EXPLORER',

  BACKEND_BRIDGE_BRANCH_ENV_DOES_NOT_EXIST = 'BACKEND_BRIDGE_BRANCH_ENV_DOES_NOT_EXIST',

  BACKEND_ENV_ALREADY_EXISTS = 'BACKEND_ENV_ALREADY_EXISTS',
  BACKEND_ENV_DOES_NOT_EXIST = 'BACKEND_ENV_DOES_NOT_EXIST',
  BACKEND_MEMBER_DOES_NOT_HAVE_ACCESS_TO_ENV = 'BACKEND_MEMBER_DOES_NOT_HAVE_ACCESS_TO_ENV',
  BACKEND_ENV_PROD_CANNOT_BE_DELETED = 'BACKEND_ENV_PROD_CANNOT_BE_DELETED',

  BACKEND_EV_ALREADY_EXISTS = 'BACKEND_EV_ALREADY_EXISTS',
  BACKEND_EV_DOES_NOT_EXIST = 'BACKEND_EV_DOES_NOT_EXIST',

  BACKEND_GIVEN_ALREADY_EXISTS = 'BACKEND_GIVEN_ALREADY_EXISTS',
  BACKEND_GIVEN_DOES_NOT_EXIST = 'BACKEND_GIVEN_DOES_NOT_EXIST',
  BACKEND_WRONG_GIVEN_VALUE = 'BACKEND_WRONG_GIVEN_VALUE',

  BACKEND_ROLE_ALREADY_EXISTS = 'BACKEND_ROLE_ALREADY_EXISTS',
  BACKEND_ROLE_DOES_NOT_EXIST = 'BACKEND_ROLE_DOES_NOT_EXIST',
  BACKEND_ROLES_DO_NOT_EXIST = 'BACKEND_ROLES_DO_NOT_EXIST',
  BACKEND_ROLE_GIVEN_ALREADY_EXISTS = 'BACKEND_ROLE_GIVEN_ALREADY_EXISTS',
  BACKEND_ROLE_GIVEN_DOES_NOT_EXIST = 'BACKEND_ROLE_GIVEN_DOES_NOT_EXIST',

  BACKEND_ENV_USER_ALREADY_EXISTS = 'BACKEND_ENV_USER_ALREADY_EXISTS',

  BACKEND_MODEL_ID_IS_NOT_DEFINED = 'BACKEND_MODEL_ID_IS_NOT_DEFINED',
  BACKEND_MODEL_DOES_NOT_EXIST = 'BACKEND_MODEL_DOES_NOT_EXIST',
  BACKEND_FORBIDDEN_MODEL = 'BACKEND_FORBIDDEN_MODEL',

  BACKEND_CHART_IS_NOT_DRAFT = 'BACKEND_CHART_IS_NOT_DRAFT',
  BACKEND_CHART_CREATOR_ID_MISMATCH = 'BACKEND_CHART_CREATOR_ID_MISMATCH',

  BACKEND_DASHBOARD_DOES_NOT_EXIST = 'BACKEND_DASHBOARD_DOES_NOT_EXIST',
  BACKEND_FORBIDDEN_DASHBOARD = 'BACKEND_FORBIDDEN_DASHBOARD',
  BACKEND_DASHBOARD_CREATOR_ID_MISMATCH = 'BACKEND_DASHBOARD_CREATOR_ID_MISMATCH',
  BACKEND_MCONFIG_PARENT_ID_MISMATCH = 'BACKEND_MCONFIG_PARENT_ID_MISMATCH',
  BACKEND_TILE_MCONFIG_ID_MISMATCH = 'BACKEND_TILE_MCONFIG_ID_MISMATCH',

  BACKEND_CHART_DOES_NOT_EXIST = 'BACKEND_CHART_DOES_NOT_EXIST',
  BACKEND_FORBIDDEN_CHART_PATH = 'BACKEND_FORBIDDEN_CHART_PATH',

  BACKEND_REPORT_DOES_NOT_EXIST = 'BACKEND_REPORT_DOES_NOT_EXIST',
  BACKEND_FORBIDDEN_REPORT = 'BACKEND_FORBIDDEN_REPORT',
  BACKEND_REPORT_NOT_FOUND = 'BACKEND_REPORT_NOT_FOUND',
  BACKEND_REPORT_CREATOR_ID_MISMATCH = 'BACKEND_REPORT_CREATOR_ID_MISMATCH',

  BACKEND_MCONFIG_DOES_NOT_EXIST = 'BACKEND_MCONFIG_DOES_NOT_EXIST',

  BACKEND_STRUCT_DOES_NOT_EXIST = 'BACKEND_STRUCT_DOES_NOT_EXIST',

  BACKEND_STRUCT_ID_CHANGED = 'BACKEND_STRUCT_ID_CHANGED',

  BACKEND_WRONG_MOTHERDUCK_DATABASE_CHARACTERS = 'BACKEND_WRONG_MOTHERDUCK_DATABASE_CHARACTERS',

  BACKEND_QUERY_DOES_NOT_EXIST = 'BACKEND_QUERY_DOES_NOT_EXIST',

  BACKEND_QUERIES_DO_NOT_EXIST = 'BACKEND_QUERIES_DO_NOT_EXIST',

  BACKEND_MCONFIG_QUERY_ID_MISMATCH = 'BACKEND_MCONFIG_QUERY_ID_MISMATCH',

  BACKEND_OLD_MCONFIG_MISMATCH = 'BACKEND_OLD_MCONFIG_MISMATCH',

  BACKEND_SCHEDULER_CHECK_BIGQUERY_RUNNING_QUERIES = 'BACKEND_SCHEDULER_CHECK_BIGQUERY_RUNNING_QUERIES',
  BACKEND_SCHEDULER_CHECK_BIGQUERY_RUNNING_QUERY = 'BACKEND_SCHEDULER_CHECK_BIGQUERY_RUNNING_QUERY',
  BACKEND_SCHEDULER_REMOVE_STRUCTS = 'BACKEND_SCHEDULER_REMOVE_STRUCTS',
  BACKEND_SCHEDULER_REMOVE_QUERIES = 'BACKEND_SCHEDULER_REMOVE_QUERIES',
  BACKEND_SCHEDULER_REMOVE_NOTES = 'BACKEND_SCHEDULER_REMOVE_NOTES',
  BACKEND_SCHEDULER_PAUSE_IDLE_EDITOR_SESSIONS_FALIED = 'BACKEND_SCHEDULER_PAUSE_IDLE_EDITOR_SESSIONS_FALIED',
  BACKEND_SCHEDULER_PAUSE_IDLE_EDITOR_SESSION_FALIED = 'BACKEND_SCHEDULER_PAUSE_IDLE_EDITOR_SESSION_FALIED',
  BACKEND_SCHEDULER_SYNC_EDITOR_SESSIONS_STATUS_FAILED = 'BACKEND_SCHEDULER_SYNC_EDITOR_SESSIONS_STATUS_FAILED',
  BACKEND_SCHEDULER_SYNC_EDITOR_SESSION_STATUS_FAILED = 'BACKEND_SCHEDULER_SYNC_EDITOR_SESSION_STATUS_FAILED',
  BACKEND_SCHEDULER_PUBLISH_RELOAD_SESSION_FAILED = 'BACKEND_SCHEDULER_PUBLISH_RELOAD_SESSION_FAILED',

  BACKEND_BIGQUERY_CANCEL_QUERY_JOB_FAIL = 'BACKEND_BIGQUERY_CANCEL_QUERY_JOB_FAIL',

  BACKEND_AVATAR_DOES_NOT_EXIST = 'BACKEND_AVATAR_DOES_NOT_EXIST',

  BACKEND_TRANSACTION_RETRY = 'BACKEND_TRANSACTION_RETRY',
  BACKEND_GET_IDEMP_RESP_RETRY = 'BACKEND_GET_IDEMP_RESP_RETRY',
  BACKEND_GET_IDEMP_RESP_RETRY_FAILED = 'BACKEND_GET_IDEMP_RESP_RETRY_FAILED',
  BACKEND_IDEMP_USER_MISMATCH = 'BACKEND_IDEMP_USER_MISMATCH',

  BACKEND_APP_FILTER_SAVE_IDEMP_ERROR = 'BACKEND_APP_FILTER_SAVE_IDEMP_ERROR',
  BACKEND_APP_FILTER_ERROR = 'BACKEND_APP_FILTER_ERROR',

  BACKEND_GET_DASHBOARD_FAIL = 'BACKEND_GET_DASHBOARD_FAIL',
  BACKEND_CREATE_DRAFT_DASHBOARD_FAILED = 'BACKEND_CREATE_DRAFT_DASHBOARD_FAILED',
  BACKEND_EDIT_DRAFT_DASHBOARD_FAILED = 'BACKEND_EDIT_DRAFT_DASHBOARD_FAILED',
  BACKEND_CREATE_DASHBOARD_FAIL = 'BACKEND_CREATE_DASHBOARD_FAIL',
  BACKEND_MODIFY_DASHBOARD_FAIL = 'BACKEND_MODIFY_DASHBOARD_FAIL',

  BACKEND_CREATE_CHART_FAIL = 'BACKEND_CREATE_CHART_FAIL',
  BACKEND_MODIFY_CHART_FAIL = 'BACKEND_MODIFY_CHART_FAIL',

  BACKEND_CREATE_REPORT_FAIL = 'BACKEND_CREATE_REPORT_FAIL',
  BACKEND_MODIFY_REPORT_FAIL = 'BACKEND_MODIFY_REPORT_FAIL',

  BACKEND_WRONG_TIME_RANGE = 'BACKEND_WRONG_TIME_RANGE',

  BACKEND_SUGGEST_FIELD_NOT_FOUND = 'BACKEND_SUGGEST_FIELD_NOT_FOUND',

  BACKEND_RUN_QUERIES_POOL_ERROR = 'BACKEND_RUN_QUERIES_POOL_ERROR',
  BACKEND_RUN_QUERY_SNOWFLAKE_ERROR = 'BACKEND_RUN_QUERY_SNOWFLAKE_ERROR',
  BACKEND_RUN_QUERY_DATABRICKS_ERROR = 'BACKEND_RUN_QUERY_DATABRICKS_ERROR',
  // BACKEND_RUN_QUERY_CLICKHOUSE_ERROR = 'BACKEND_RUN_QUERY_CLICKHOUSE_ERROR',
  BACKEND_RUN_QUERY_POSTGRES_ERROR = 'BACKEND_RUN_QUERY_POSTGRES_ERROR',
  BACKEND_RUN_QUERY_MYSQL_ERROR = 'BACKEND_RUN_QUERY_MYSQL_ERROR',
  BACKEND_RUN_QUERY_PRESTO_ERROR = 'BACKEND_RUN_QUERY_PRESTO_ERROR',
  BACKEND_RUN_QUERY_TRINO_ERROR = 'BACKEND_RUN_QUERY_TRINO_ERROR',
  BACKEND_RUN_QUERY_DUCKDB_ERROR = 'BACKEND_RUN_QUERY_DUCKDB_ERROR',
  BACKEND_RUN_QUERY_API_ERROR = 'BACKEND_RUN_QUERY_API_ERROR',

  BACKEND_SNOWFLAKE_FAILED_TO_CONNECT = 'BACKEND_SNOWFLAKE_FAILED_TO_CONNECT',
  BACKEND_SNOWFLAKE_FAILED_TO_DESTROY_CONNECTION = 'BACKEND_SNOWFLAKE_FAILED_TO_DESTROY_CONNECTION',

  BACKEND_DATABRICKS_FAILED_TO_CLOSE_CONNECTION = 'BACKEND_DATABRICKS_FAILED_TO_CLOSE_CONNECTION',

  BACKEND_MALLOY_CONNECTION_CLOSE_ERROR = 'BACKEND_MALLOY_CONNECTION_CLOSE_ERROR',
  BACKEND_MYSQL_CONNECTION_CLOSE_ERROR = 'BACKEND_MYSQL_CONNECTION_CLOSE_ERROR',

  BACKEND_FETCH_FK_POSTGRES_ERROR = 'BACKEND_FETCH_FK_POSTGRES_ERROR',
  BACKEND_FETCH_FK_MYSQL_ERROR = 'BACKEND_FETCH_FK_MYSQL_ERROR',
  BACKEND_FETCH_FK_BIGQUERY_ERROR = 'BACKEND_FETCH_FK_BIGQUERY_ERROR',
  BACKEND_FETCH_FK_SNOWFLAKE_ERROR = 'BACKEND_FETCH_FK_SNOWFLAKE_ERROR',
  BACKEND_FETCH_FK_DUCKDB_ERROR = 'BACKEND_FETCH_FK_DUCKDB_ERROR',
  BACKEND_FETCH_FK_DATABRICKS_ERROR = 'BACKEND_FETCH_FK_DATABRICKS_ERROR',

  BACKEND_FETCH_CONSTRAINTS_SNOWFLAKE_ERROR = 'BACKEND_FETCH_CONSTRAINTS_SNOWFLAKE_ERROR',
  BACKEND_FETCH_CONSTRAINTS_DUCKDB_ERROR = 'BACKEND_FETCH_CONSTRAINTS_DUCKDB_ERROR',
  BACKEND_FETCH_CONSTRAINTS_DATABRICKS_ERROR = 'BACKEND_FETCH_CONSTRAINTS_DATABRICKS_ERROR',
  BACKEND_FETCH_CONSTRAINTS_BIGQUERY_ERROR = 'BACKEND_FETCH_CONSTRAINTS_BIGQUERY_ERROR',

  BACKEND_FETCH_DATASET_BIGQUERY_ERROR = 'BACKEND_FETCH_DATASET_BIGQUERY_ERROR',

  BACKEND_API_INVALID_URL = 'BACKEND_API_INVALID_URL',
  BACKEND_API_PROTOCOL_MUST_BE_HTTPS_OR_HTTP = 'BACKEND_API_PROTOCOL_MUST_BE_HTTPS_OR_HTTP',
  BACKEND_API_HOST_IS_BLOCKED_BY_LIST = 'BACKEND_API_HOST_IS_BLOCKED_BY_LIST',
  BACKEND_API_HOST_IS_BLOCKED_BY_SPEC = 'BACKEND_API_HOST_IS_BLOCKED_BY_SPEC',
  BACKEND_API_HOST_IS_BLOCKED_BY_SUFFIX = 'BACKEND_API_HOST_IS_BLOCKED_BY_SUFFIX',
  BACKEND_API_HOST_IS_BLOCKED_BY_IP = 'BACKEND_API_HOST_IS_BLOCKED_BY_IP',
  BACKEND_API_HOST_DNS_LOOKUP_FAILED = 'BACKEND_API_HOST_DNS_LOOKUP_FAILED',

  BACKEND_TEST_CONNECTION_RESULT_IS_NOT_DEFINED = 'BACKEND_TEST_CONNECTION_RESULT_IS_NOT_DEFINED',

  BACKEND_WRONG_TOTAL_DISK_SHARDS = 'BACKEND_WRONG_TOTAL_DISK_SHARDS',

  BACKEND_RPC_TIMEOUT = 'BACKEND_RPC_TIMEOUT',
  BACKEND_RPC_INVALID_RESPONSE_FORMAT = 'BACKEND_RPC_INVALID_RESPONSE_FORMAT',

  BACKEND_FORWARD_TELEMETRY_LOGS_ERROR = 'BACKEND_FORWARD_TELEMETRY_LOGS_ERROR',
  BACKEND_FORWARD_TELEMETRY_METRICS_ERROR = 'BACKEND_FORWARD_TELEMETRY_METRICS_ERROR',
  BACKEND_FORWARD_TELEMETRY_TRACES_ERROR = 'BACKEND_FORWARD_TELEMETRY_TRACES_ERROR',

  BACKEND_UNKNOWN_SANDBOX_TYPE = 'BACKEND_UNKNOWN_SANDBOX_TYPE',
  BACKEND_EDITOR_SESSION_LOCK_FAILED = 'BACKEND_EDITOR_SESSION_LOCK_FAILED',
  BACKEND_SANDBOX_CREATE_FAILED = 'BACKEND_SANDBOX_CREATE_FAILED',
  BACKEND_SANDBOX_OPENCODE_REFRESH_FAILED = 'BACKEND_SANDBOX_OPENCODE_REFRESH_FAILED',
  BACKEND_SANDBOX_HEALTH_CHECK_FAILED = 'BACKEND_SANDBOX_HEALTH_CHECK_FAILED',
  BACKEND_SANDBOX_GIT_CLONE_FAILED = 'BACKEND_SANDBOX_GIT_CLONE_FAILED',
  BACKEND_SANDBOX_GIT_CHECKOUT_FAILED = 'BACKEND_SANDBOX_GIT_CHECKOUT_FAILED',
  BACKEND_SANDBOX_NOT_FOUND = 'BACKEND_SANDBOX_NOT_FOUND',
  BACKEND_SANDBOX_EXPIRED = 'BACKEND_SANDBOX_EXPIRED',
  BACKEND_SANDBOX_PAUSE_NOT_SUPPORTED = 'BACKEND_SANDBOX_PAUSE_NOT_SUPPORTED',
  BACKEND_SESSION_NOT_FOUND = 'BACKEND_SESSION_NOT_FOUND',
  BACKEND_SESSION_NOT_READY = 'BACKEND_SESSION_NOT_READY',
  BACKEND_SESSION_IS_ARCHIVED = 'BACKEND_SESSION_IS_ARCHIVED',
  BACKEND_SESSION_IS_IN_ERROR_STATE = 'BACKEND_SESSION_IS_IN_ERROR_STATE',

  BACKEND_TOO_MANY_ACTIVE_EDITOR_SESSIONS = 'BACKEND_TOO_MANY_ACTIVE_EDITOR_SESSIONS',
  BACKEND_CREATE_SESSION_FAILED = 'BACKEND_CREATE_SESSION_FAILED',
  BACKEND_FAILED_TO_GET_INITIAL_COMMIT = 'BACKEND_FAILED_TO_GET_INITIAL_COMMIT',
  BACKEND_SET_MODEL_FAILED = 'BACKEND_SET_MODEL_FAILED',
  BACKEND_MESSAGE_AGENT_REQUIRED = 'BACKEND_MESSAGE_AGENT_REQUIRED',
  BACKEND_MESSAGE_PROVIDER_REQUIRED = 'BACKEND_MESSAGE_PROVIDER_REQUIRED',
  BACKEND_MESSAGE_MODEL_REQUIRED = 'BACKEND_MESSAGE_MODEL_REQUIRED',
  BACKEND_MESSAGE_VARIANT_REQUIRED = 'BACKEND_MESSAGE_VARIANT_REQUIRED',
  BACKEND_EXPLORER_CONTEXT_LIMIT_REACHED = 'BACKEND_EXPLORER_CONTEXT_LIMIT_REACHED',
  BACKEND_PROMPT_FAILED = 'BACKEND_PROMPT_FAILED',
  BACKEND_GET_PROVIDER_MODEL_FAILED = 'BACKEND_GET_PROVIDER_MODEL_FAILED',
  BACKEND_ABORT_FAILED = 'BACKEND_ABORT_FAILED',
  BACKEND_INTERACT_TIMEOUT = 'BACKEND_INTERACT_TIMEOUT',
  BACKEND_INTERACT_FAILED = 'BACKEND_INTERACT_FAILED',
  BACKEND_FETCH_TIMEOUT = 'BACKEND_FETCH_TIMEOUT',
  BACKEND_FETCH_FAILED = 'BACKEND_FETCH_FAILED',
  BACKEND_RESPOND_TO_QUESTION_FAILED = 'BACKEND_RESPOND_TO_QUESTION_FAILED',
  BACKEND_RESPOND_TO_PERMISSION_FAILED = 'BACKEND_RESPOND_TO_PERMISSION_FAILED',

  BACKEND_DRAIN_QUEUES_FAILED = 'BACKEND_DRAIN_QUEUES_FAILED',
  BACKEND_DRAIN_QUEUE_FAILED = 'BACKEND_DRAIN_QUEUE_FAILED',
  BACKEND_REDIS_SUBSCRIBE_FAILED = 'BACKEND_REDIS_SUBSCRIBE_FAILED',
  BACKEND_REDIS_UNSUBSCRIBE_FAILED = 'BACKEND_REDIS_UNSUBSCRIBE_FAILED',
  BACKEND_SSE_STREAM_FAILED = 'BACKEND_SSE_STREAM_FAILED',
  BACKEND_SSE_POLL_DB_FAILED = 'BACKEND_SSE_POLL_DB_FAILED',
  BACKEND_STOP_STREAM_PUBSUB_FAILED = 'BACKEND_STOP_STREAM_PUBSUB_FAILED',
  BACKEND_REFRESH_STREAM_LOCKS_FAILED = 'BACKEND_REFRESH_STREAM_LOCKS_FAILED',
  BACKEND_SAFE_PAUSE_SESSION_FAILED = 'BACKEND_SAFE_PAUSE_SESSION_FAILED',
  BACKEND_REFETCH_FROM_OPENCODE_FAILED = 'BACKEND_REFETCH_FROM_OPENCODE_FAILED',
  BACKEND_STREAM_STALL_CHECK_FAILED = 'BACKEND_STREAM_STALL_CHECK_FAILED',
  BACKEND_AI_SDK_STREAM_COMMAND_FAILED = 'BACKEND_AI_SDK_STREAM_COMMAND_FAILED',

  // DISK

  DISK_APP_TERMINATED = 'DISK_APP_TERMINATED',
  DISK_UNCAUGHT_EXCEPTION = 'DISK_UNCAUGHT_EXCEPTION',
  DISK_UNHANDLED_REJECTION_REASON = 'DISK_UNHANDLED_REJECTION_REASON',
  DISK_UNHANDLED_REJECTION_ERROR = 'DISK_UNHANDLED_REJECTION_ERROR',

  DISK_WRONG_ENV_VALUES = 'DISK_WRONG_ENV_VALUES',

  DISK_WRONG_REQUEST_INFO_NAME = 'DISK_WRONG_REQUEST_INFO_NAME',
  DISK_WRONG_REQUEST_PARAMS = 'DISK_WRONG_REQUEST_PARAMS',

  DISK_ORG_ALREADY_EXIST = 'DISK_ORG_ALREADY_EXIST',
  DISK_ORG_IS_NOT_EXIST = 'DISK_ORG_IS_NOT_EXIST',

  DISK_PROJECT_ALREADY_EXIST = 'DISK_PROJECT_ALREADY_EXIST',
  DISK_PROJECT_IS_NOT_EXIST = 'DISK_PROJECT_IS_NOT_EXIST',

  DISK_REPO_ALREADY_EXIST = 'DISK_REPO_ALREADY_EXIST',
  DISK_REPO_IS_NOT_EXIST = 'DISK_REPO_IS_NOT_EXIST',

  DISK_REPO_IS_NOT_CLEAN_FOR_CHECKOUT_BRANCH = 'DISK_REPO_IS_NOT_CLEAN_FOR_CHECKOUT_BRANCH',
  DISK_REPO_STATUS_IS_NOT_NEED_PUSH = 'DISK_REPO_STATUS_IS_NOT_NEED_PUSH',

  DISK_DEV_REPO_COMMIT_DOES_NOT_MATCH_LOCAL_COMMIT = 'DISK_DEV_REPO_COMMIT_DOES_NOT_MATCH_LOCAL_COMMIT',

  DISK_BRANCH_ALREADY_EXIST = 'DISK_BRANCH_ALREADY_EXIST',
  DISK_BRANCH_IS_NOT_EXIST = 'DISK_BRANCH_IS_NOT_EXIST',
  DISK_THEIR_BRANCH_IS_NOT_EXIST = 'DISK_THEIR_BRANCH_IS_NOT_EXIST',
  DISK_REMOTE_BRANCH_IS_NOT_EXIST = 'DISK_REMOTE_BRANCH_IS_NOT_EXIST',
  DISK_DEFAULT_BRANCH_CANNOT_BE_DELETED = 'DISK_DEFAULT_BRANCH_CANNOT_BE_DELETED',

  DISK_NEW_PATH_ALREADY_EXIST = 'DISK_NEW_PATH_ALREADY_EXIST',
  DISK_TO_PATH_ALREADY_EXIST = 'DISK_TO_PATH_ALREADY_EXIST',

  DISK_PARENT_PATH_IS_NOT_EXIST = 'DISK_PARENT_PATH_IS_NOT_EXIST',
  DISK_FROM_PATH_IS_NOT_EXIST = 'DISK_FROM_PATH_IS_NOT_EXIST',
  DISK_OLD_PATH_IS_NOT_EXIST = 'DISK_OLD_PATH_IS_NOT_EXIST',

  DISK_FOLDER_ALREADY_EXIST = 'DISK_FOLDER_ALREADY_EXIST',
  DISK_FOLDER_IS_NOT_EXIST = 'DISK_FOLDER_IS_NOT_EXIST',

  DISK_FILE_ALREADY_EXIST = 'DISK_FILE_ALREADY_EXIST',
  DISK_FILE_IS_NOT_EXIST = 'DISK_FILE_IS_NOT_EXIST',

  DISK_PATH_TRAVERSAL = 'DISK_PATH_TRAVERSAL',

  // BLOCKML

  BLOCKML_APP_TERMINATED = 'BLOCKML_APP_TERMINATED',
  BLOCKML_UNCAUGHT_EXCEPTION = 'BLOCKML_UNCAUGHT_EXCEPTION',
  BLOCKML_UNHANDLED_REJECTION_REASON = 'BLOCKML_UNHANDLED_REJECTION_REASON',
  BLOCKML_UNHANDLED_REJECTION_ERROR = 'BLOCKML_UNHANDLED_REJECTION_ERROR',

  BLOCKML_WRONG_ENV_VALUES = 'BLOCKML_WRONG_ENV_VALUES',

  BLOCKML_WRONG_REQUEST_INFO_NAME = 'BLOCKML_WRONG_REQUEST_INFO_NAME',
  BLOCKML_WRONG_REQUEST_PARAMS = 'BLOCKML_WRONG_REQUEST_PARAMS',

  BLOCKML_MALLOY_CONNECTION_CLOSE_ERROR = 'BLOCKML_MALLOY_CONNECTION_CLOSE_ERROR',

  BLOCKML_LOAD_PRESETS_FAILED = 'BLOCKML_LOAD_PRESETS_FAILED',

  BLOCKML_UNEXPECTED_URL_READ = 'BLOCKML_UNEXPECTED_URL_READ',

  // MCLI

  MCLI_APP_TERMINATED = 'MCLI_APP_TERMINATED',
  MCLI_UNCAUGHT_EXCEPTION = 'MCLI_UNCAUGHT_EXCEPTION',
  MCLI_UNHANDLED_REJECTION_REASON = 'MCLI_UNHANDLED_REJECTION_REASON',
  MCLI_UNHANDLED_REJECTION_ERROR = 'MCLI_UNHANDLED_REJECTION_ERROR',

  MCLI_WRONG_ENV_VALUES = 'MCLI_WRONG_ENV_VALUES',

  MCLI_ERROR_RESPONSE_FROM_BACKEND = 'MCLI_ERROR_RESPONSE_FROM_BACKEND',

  BACKEND_DASHBOARD_NOT_FOUND = 'BACKEND_DASHBOARD_NOT_FOUND',
  BACKEND_CHART_NOT_FOUND = 'BACKEND_CHART_NOT_FOUND',

  MCLI_PROJECT_ID_IS_NOT_DEFINED = 'MCLI_PROJECT_ID_IS_NOT_DEFINED',
  MCLI_SYNC_FAILED = 'MCLI_SYNC_FAILED',

  MCLI_TEST_RETRY = 'MCLI_TEST_RETRY',

  // BACKEND API KEY

  BACKEND_WRONG_API_KEY_FORMAT = 'BACKEND_WRONG_API_KEY_FORMAT',
  BACKEND_API_KEY_NOT_FOUND = 'BACKEND_API_KEY_NOT_FOUND',
  BACKEND_API_KEY_NOT_VALID = 'BACKEND_API_KEY_NOT_VALID',
  BACKEND_USER_API_KEY_REQUEST_NOT_ALLOWED = 'BACKEND_USER_API_KEY_REQUEST_NOT_ALLOWED',
  BACKEND_SESSION_API_KEY_REQUEST_NOT_ALLOWED = 'BACKEND_SESSION_API_KEY_REQUEST_NOT_ALLOWED',
  BACKEND_PROJECT_ID_DOES_NOT_MATCH_SESSION = 'BACKEND_PROJECT_ID_DOES_NOT_MATCH_SESSION',
  BACKEND_REPO_ID_DOES_NOT_MATCH_SESSION = 'BACKEND_REPO_ID_DOES_NOT_MATCH_SESSION',
  BACKEND_REPO_ID_DOES_NOT_MATCH_USER = 'BACKEND_REPO_ID_DOES_NOT_MATCH_USER',
  BACKEND_ENV_ID_DOES_NOT_MATCH_SESSION = 'BACKEND_ENV_ID_DOES_NOT_MATCH_SESSION',
  BACKEND_BRANCH_ID_DOES_NOT_MATCH_SESSION = 'BACKEND_BRANCH_ID_DOES_NOT_MATCH_SESSION',

  BACKEND_TEST_RETRY = 'BACKEND_TEST_RETRY',

  // NODE COMMON

  FILE_SIZE_IS_TOO_BIG = 'FILE_SIZE_IS_TOO_BIG',
  FILE_IS_SYMLINK = 'FILE_IS_SYMLINK',
  MALLOY_TO_QUERY_FAILED = 'MALLOY_TO_QUERY_FAILED',

  // COMMON

  ENV_VAR_VALUE_MUST_BE_TRUE_OR_FALSE = 'ENV_VAR_VALUE_MUST_BE_TRUE_OR_FALSE'
}
